window.app = window.app || {};

(function($) {

	formHelper.always.xhrReady = function(xhrOptions) {

		this.$form.find('select.js-country-select').each(function() {
			var $countrySelect = $(this);
			var countryCode = $countrySelect.find('option:selected').data('country-code');
			var countryCodeISO = $countrySelect.find('option:selected').data('country-code-iso');
			var countryCodeLocalizedName = $countrySelect.find('option:selected').text();
			var countryArgName = $countrySelect.find('option:selected').data('country-code-arg');
			xhrOptions.data[countryArgName] = countryCode;
			xhrOptions.data[countryArgName + '-localized'] = countryCodeLocalizedName;
			xhrOptions.data[countryArgName + '-iso'] = countryCodeISO;
		});

	};

})(jQuery);
